import siteId from './site-id';

export default {
  siteId,
};
